import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import DatePickerCom from "./DatePickerCom";
import BrandSearchCom from "../../basic-information/brand/BrandSearchCom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useSnackbar } from "notistack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function BrandReport(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [name, setName] = useState("");
  const [state, setState] = useState({
    productID: 0,
    brandID: undefined,
    groupID: 0,
    categoryID: 0,
    date1: undefined,
    date2: undefined,
  });
  const { isSmall } = useBreakpoints();

  const [errorState, setErrorState] = useState({
    date1: false,
    date2: false,
    brandID: false,
  });

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion
      expanded={props.expanded === "panel2"}
      onChange={handleChange("panel2")}
      style={{
        margin: isSmall ? 0 : "20px",
        marginBottom: isSmall && "20px",
        paddingBottom: "15px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            گزارش فروش برند
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            p: 1,
            py: 0,
            borderRadius: 2,
          }}
        >
          <DatePickerCom state={state} setState={setState} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: isSmall ? "100" : "45%",
              mt: 3,
            }}
          >
            {props.expanded === "panel2" && (
              <BrandSearchCom
                setName={setName}
                validation={errorState.brandID}
                selectedBrandID={state.brandID}
                setter={setState}
                lvl1State={state}
                Offer
              ></BrandSearchCom>
            )}
            <Button
              disabled={!state.brandID ? true : false}
              sx={{ ml: 2 }}
              onClick={() => {
                if (!state.date1 || !state.date2) {
                  enqueueSnackbar("لطفا تاریخ را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                } else if (!state.brandID) {
                  enqueueSnackbar("لطفا برند را انتخاب کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                } else {
                  props.callback(state);
                }
              }}
              variant="contained"
            >
              نمایش
            </Button>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
